import { Panel } from '../../UI/Panel'
import { Text } from '@pixi/react'
import { TextStyle } from 'pixi.js'

interface BetHistoryHeaderColProps {
  x: number
  y: number
  width: number
  height: number
  text: string
}

export const BetHistoryHeaderColPortrait = (props: BetHistoryHeaderColProps) => {
  return (
    <Panel x={props.x} y={props.y} width={props.width} height={props.height} backgroundColor="#C0C0C0">
      <Text
        text={props.text}
        x={props.width / 2}
        y={props.height / 2}
        anchor={0.5}
        style={new TextStyle({
          align: 'center',
          fontSize: 20,
          fontWeight: 'normal',
          fill: '#000000',
          wordWrap: true,
          breakWords: true,
          wordWrapWidth: props.width,
        })}
      />
    </Panel>
  )
}
